import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Icon from '../../utils/icon';
import theme from '../../utils/constants';

const useStyles = makeStyles((theme) => ({
  cards: {
    borderRadius: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: 500,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  cardcontenttype: {
    backgroundColor: theme.palette.primary.highlight,
    padding: theme.spacing(0, 1.5),
    borderRadius: theme.spacing(2),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1
  },
  cardfeaturedtype: {
    backgroundColor: '#FDB515',
    padding: theme.spacing(0, 2.5, 0, 1.5),
    borderRadius: theme.spacing(2),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1,
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 0px 12px 5px rgba(253,181,21,0.3)'
  }
}));

const listCategories = (categoriesitem) => {
  return categoriesitem?.map((item, index) => {
    return (
      <Box
        key={index * Math.random() * 100}
        width={42}
        height={42}
        borderRadius={100}
        className={item.taxItemName_s}
        display='flex'
        alignItems='center'
        justifyContent='center'
        ml={1}
      >
        <Icon
          name={item.taxItemName_s}
          color='#ffffff'
          widthsize={30}
          heightsize={30}
        />
      </Box>
    );
  });
};

export default function FeaturedCard2Up(props) {
  const { ice } = props;
  const classes = useStyles();
  return (
    <Box
      className={
        'promotionalcard featureddynamicshadow cards-ie ' + classes.cards
      }
      component={Card}
      style={{
        border: '1px solid #fafafa',
        backgroundImage:
          'linear-gradient(180deg, rgba(0,42,84,1) 0%, rgba(0,42,84,0.25) 50%, rgba(0,42,84,1) 100%), url("' +
          props.image +
          '")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top'
      }}
    >
      <Box
        width={1}
        p={2}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <Typography
          variant='overline'
          className={classes.cardcontenttype}
          gutterBottom
        >
          {props.contenttype}
        </Typography>
        <Box display='flex'>{listCategories(props.categories)}</Box>
      </Box>
      <CardContent>
        <Box
          py={6}
          px={3}
          bgcolor={theme.palette.common.white}
          borderRadius={theme.spacing(4)}
          height={175}
          display='flex'
          justifyContent='center'
          alignItems='center'
          textAlign='center'
          flexDirection='column'
          className='promotionalcard'
        >
          <Box pb={3}>
            <Icon name={props.icon} widthsize={32} heightsize={32} />
          </Box>
          <Typography
            ice={ice}
            variant='overline'
            gutterBottom
            style={{ lineHeight: 1.5 }}
          >
            {props.subtitle}
          </Typography>
          <Typography variant='h5'> {props.title} </Typography>
        </Box>
      </CardContent>
      <CardActions>
        <Box display='flex' justifyContent='flex-end' width={1} px={2} py={1}>
          <Button
            variant='contained'
            color='secondary'
            className='button-main'
            size='large'
            href={props.link}
          >
            {props.buttontext}
          </Button>
        </Box>
      </CardActions>
    </Box>
  );
}
